import { useEffect, useState } from "react";
import { adminApi } from "@/lib/api";

export function useAdminUser(skip = false) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (skip) return;
    adminApi.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, [skip]);

  return [user, setUser];
}

export const startGoogleLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/admin";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const AdminShell = ({ children }) => (
  <div className="min-h-screen bg-[#F5F3EC]">
    <header className="border-b border-slate-200 bg-white">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 lg:px-8">
        <a href="/" className="font-display text-lg font-bold tracking-wide text-[#0B132B]">VERTEXHUB <span className="text-gold">ADMIN</span></a>
      </div>
    </header>
    {children}
  </div>
);
